import React, {
  createContext,
  useContext,
  useCallback,
  useMemo,
  useState,
} from "react";

const ZonesSelectionContext = createContext(null);

export function ZonesSelectionProvider({ children }) {
  const [selectedZones, setSelectedZones] = useState([]);
  // const addZone = useCallback((id) => {
  //   setSelectedZones((prev) => (prev.includes(id) ? prev : [...prev, id]));
  // }, []);

  // const deleteZone = useCallback((id) => {
  //   setSelectedZones((prev) => prev.filter((z) => z !== id));
  // }, []);

  // const restoreZones = useCallback((idsArray) => {
  //   setSelectedZones(idsArray || []);
  // }, []);

  // const selectAllZones = useCallback((idsArray) => {
  //   setSelectedZones([...idsArray]);
  // }, []);
  const addZone = useCallback((zone) => {
    setSelectedZones((prev) =>
      prev.find((prevZone) => prevZone._id === zone._id)
        ? prev
        : [...prev, zone]
    );
  }, []);

  const deleteZone = useCallback((id) => {
    setSelectedZones((prev) => prev.filter((z) => z._id !== id));
  }, []);

  const restoreZones = useCallback((zonesArray) => {
    setSelectedZones(zonesArray || []);
  }, []);

  const selectAllZones = useCallback((zonesArray) => {
    setSelectedZones([...zonesArray]);
  }, []);

  const value = useMemo(
    () => ({
      selectedZones,
      addZone,
      deleteZone,
      restoreZones,
      selectAllZones,
    }),
    [selectedZones, addZone, deleteZone, restoreZones, selectAllZones]
  );

  return (
    <ZonesSelectionContext.Provider value={value}>
      {children}
    </ZonesSelectionContext.Provider>
  );
}

export function useZonesSelection() {
  const ctx = useContext(ZonesSelectionContext);
  if (!ctx) {
    throw new Error(
      "useZonesSelection must be used within a ZonesSelectionProvider"
    );
  }
  return ctx;
}
